import React, { useState, createContext } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth';
import {
  MyBlockMonth,
  MyBlockMonthDates,
  SearchDate
} from '../models/MyBlockMonthInterface';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';
import { addPairingDetailToActivities } from '../pages/MyBlockMonth/myBlockMonthHelper';

const myBlockMonthDefault: any = {};
const myBlockMonthDatesDefault: any = [];
const MyBlockMonthContext = createContext({
  loading: true,
  myBlockMonthDates: myBlockMonthDatesDefault as MyBlockMonthDates[],
  myBlockMonthData: myBlockMonthDefault as MyBlockMonth,
  getMyBlockMonthData: (search: SearchDate, actual: boolean) => {},
  getMyBlockMonthDates: () => {}
});

export const MyBlockMonthProvider = (props) => {
  const { user } = useAuth();
  const { setErrorCode } = useApiError();
  const [loading, setLoading] = useState(true);
  const [myBlockMonthData, setMyBlockMonthData] =
    useState<MyBlockMonth>(myBlockMonthDefault);
  const [myBlockMonthDates, setMyBlockMonthDates] = useState<
    MyBlockMonthDates[]
  >(myBlockMonthDatesDefault);

  const getMyBlockMonthDates = async () => {
    if (!user) {
      return;
    }
    try {
      setLoading(true);
      const datesData = await API.get('crewlife', `/myblockmonth/list`, {});
      setMyBlockMonthDates(datesData.reverse());
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      if (e.response?.status) {
        setErrorCode(e.response?.status);
      } else {
        setErrorCode(error.DEFAULT);
      }
    }
  };

  const getMyBlockMonthData = async (search, actual) => {
    if (!user || !search) {
      return;
    }
    try {
      setLoading(true);
      const requestObject = {
        body: {
          ...search,
          actual: actual
        }
      };
      const blockMonthData = await API.post(
        'crewlife',
        '/myblockmonth/calendar',
        requestObject
      );
      if (blockMonthData.pairingList.length)
        addPairingDetailToActivities(
          blockMonthData.activities,
          blockMonthData.pairingList
        );
      setMyBlockMonthData({ ...blockMonthData });
      setLoading(false);
    } catch (e: any) {
      if (e.response?.status) {
        setErrorCode(e.response?.status);
      } else {
        setErrorCode(error.DEFAULT);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <MyBlockMonthContext.Provider
      value={{
        loading,
        myBlockMonthDates,
        myBlockMonthData,
        getMyBlockMonthData,
        getMyBlockMonthDates
      }}
    >
      {props.children}
    </MyBlockMonthContext.Provider>
  );
};

export const useMyBlockMonthProvider = () => {
  return React.useContext(MyBlockMonthContext);
};
